import { data } from 'jquery';
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { View, Text, TextInput, Pressable, Dimensions, PanResponder } from 'react-native';
import * as SVG from 'react-native-svg';
import toTitleCase from '@hooks/toTitleCase';
import { DefaultRootState, store } from '@reduxLocal/persistState';
import { useDispatch, useSelector } from 'react-redux';
import { Gesture, GestureDetector } from 'react-native-gesture-handler';
import * as Animatable from 'react-native-animatable';
import { ADD_DATA_ITEM, CHANGE_ITEM_DATA_TITLE, CHANGE_ITEM_DATA_TYPE } from '@reduxLocal/actions/types';
import { Title } from '@constants/Themed';
import DropDownPicker from 'react-native-dropdown-picker';
import dataTypes from '../utils/dataTypes';
import styles from '@stylesheet';
import { Entypo } from "@expo/vector-icons";
import { DragableView } from './elements/SharedElements';
import { Ionicons } from '@expo/vector-icons';
import { AntDesign } from '@expo/vector-icons';
import { Fontisto } from '@expo/vector-icons';
import ExamplePreviewHandler from './elements/ExamplePreviewHandler';
import parseByDelimiter from '@utils/parseByDelimiter';

interface PreviewComponent {
  visible?: boolean,
  dataField?: any,
  indexLength: number,
  currentIndex: number,
  interaction?: boolean,
  toolbarRef?: any
}


const TutorialPreview = ({ visible, dataField, indexLength, currentIndex, interaction }: PreviewComponent) => {
  const [dataType, setDataType] = useState('');
  const [dataPlaceHolder, setDataPlaceHolder] = useState('');
  const [selected, setSelected] = useState(false);
  const [responder, setResponder] = useState(false);
  const draggedItem = useSelector((state: DefaultRootState) => state.toolbar.toolbarItemDragged)
  const [open, setOpen] = useState(false);
  const [dataTypeField, setDataTypeField] = useState(null);
  const [items, setItems] = useState(dataTypes);
  const [categoryOpen, setCategoryOpen] = useState(false)
  const [gestureActive, setGestureActive] = useState(false);
  const dragRef = useRef(null);
  const topRef = useRef(null);
  const bottomRef = useRef(null);
  const dispatch = useDispatch();

  const [options, setOptions] = useState(false);

  const openArrow = () => { return (<View style={{ alignSelf: 'center' }}><Entypo name={"chevron-thin-up"} style={[styles.menuItemIcon, { alignSelf: 'center', alignContent: 'center', alignItems: 'center' }]} size={10} color={'white'} ></Entypo></View>) }
  const closeArrow = () => { return (<Entypo name={"chevron-thin-down"} style={[styles.menuItemIcon, { alignSelf: 'center', alignContent: 'center', alignItems: 'center' }]} size={10} color={'white'} ></Entypo>) }

  useEffect(() => {
    if (dataField != null) {
      setDataType(Object.keys(dataField)[0])
    }
  }, [dataField])


  const onDataTypeOpen = useCallback(() => {
    setCategoryOpen(false);
  }, [])

  function typeHandler(contentType) {
    if (contentType === 'string') {
      return 'Text entry'
    }
  }

  const handleDataTypeChange = (value) => {
    console.log(value)
    // setDataTypeField(value.value)
    dispatch({
      type: CHANGE_ITEM_DATA_TYPE, payload: {
        index: currentIndex, newValue: {
          data: value.data,
          dataCategory: value.dataCategory,
          headers: value.headerField,
          key: value.key,
          dataTypes: value.value
        }
      }
    })
  }

  return (
    <Animatable.View useNativeDriver animation={'fadeIn'} delay={currentIndex * 100} style={{ flex: 1, flexDirection: 'row', padding: 20, alignSelf: 'flex-start', left: -50, maxWidth: '100%', backgroundColor: "white" }}>
      <View style={{ top: 40 }}>
        <SVG.Svg width={100} height={100} style={{ flex: 1, marginRight: -20, marginTop: -40 }}>
          <SVG.Circle cx={10} cy={10} r={5} scale={3} stroke={'rgba(90,192,234,33)'} strokeWidth={2} fill={!selected ? 'white' : 'rgb(90,192,234)'} />
        </SVG.Svg>
        {
          visible ?
            <View >
              <SVG.Svg width={60} height={60} style={{ flex: 1, marginRight: -20 }}>
                <SVG.Circle cx={10} cy={10} r={5} scale={3} stroke={'rgba(90,192,234,33)'} strokeWidth={2} fill={'white'} />
              </SVG.Svg>
            </View>
            :
            null
        }
        <>
          <SVG.Svg width={60} height={'120%'} style={{ flex: 1, position: 'absolute', left: 25, zIndex: -1 }}>
            <SVG.Defs>
              <SVG.LinearGradient id="uniqueLineGradient" x1="0" x2="0" y1="0" y2="1">
                <SVG.Stop offset={'0%'} stopColor={'rgb(90,192,234)'} />
                <SVG.Stop offset={'30%'} stopColor={'rgba(90,123,234,0)'} stopOpacity={0} />
              </SVG.LinearGradient>
            </SVG.Defs>
            {
              currentIndex > indexLength - 2 ?
                null
                :
                <SVG.Rect id={'Somenewid'} width={10} height={Dimensions.get('window').height} fill={"url(#uniqueLineGradient)"} />
            }
          </SVG.Svg >
        </>
      </View>
      <View style={{ flex: 1, minWidth:"80%" }}>
        <View style={{ flex: 1 }}>
          <View style={{ flex: 1, flexDirection: 'row', marginBottom: 40, overflow: 'visible' }}>
            <View style={{ zIndex: -1, flex: 1, borderRadius: 2, marginRight: -30, transform: [{ rotateZ: '45deg' }], backgroundColor: 'rgba(90,192,234,1)', maxHeight: 15, maxWidth: 15, left: -20, top: 23, shadowRadius: 20, shadowOpacity: .2 }} />
            <Animatable.View transition={'height'} style={{ padding: 10, paddingHorizontal: 15, flex: 5, backgroundColor: 'rgba(90,192,234,1)', height: options ? 180 : 80, borderRadius: 20, overflow: 'visible' }}>
              <View style={{ flexDirection: 'row', alignContent: 'stretch', gap: 30, alignSelf: 'stretch', overflow: 'hidden' }}>
                <TextInput value={parseByDelimiter(dataField?.title)} editable={interaction ? interaction : false} onChangeText={(v) => { setDataType(v);
                  dispatch({ type: CHANGE_ITEM_DATA_TITLE, payload: v, index: currentIndex })
                }} 
                  style={{ top: -10, flex: 2, fontWeight: '400', padding: 20, maxWidth: 300 }}
                   />
              </View>
            </Animatable.View>
          </View>
          {
            selected &&
            <Animatable.View useNativeDriver animation={'fadeInDown'} style={{ gap: 10, marginBottom: 40, borderWidth: 3, borderRadius: 20, padding: 15, zIndex: -10 }}>
              <Title style={{ marginTop: -30, backgroundColor: '#ececec', paddingHorizontal: 10, maxWidth: 100, borderRadius: 20 }}>Preview</Title>
              <View style={{ flex: 1, backgroundColor: '#ececec', borderRadius: 20, shadowRadius: 20, shadowOpacity: .2, justifyContent: 'center', alignContent: 'center' }}>
                <View style={[styles.centerEverything, { margin: 10, flexDirection: 'row', minWidth: '100%' }]}>
                    <Text adjustsFontSizeToFit style={{ flex: 2, minWidth: 70 }}>{toTitleCase(dataField?.title || '')}</Text>
                  <View style={{ flex: 5 }}>
                    <ExamplePreviewHandler componentType={dataField.type} defaultValue={null} parameters={{}} />
                  </View>
                </View>
              </View>
            </Animatable.View>
          }
        </View>
      </View>
    </Animatable.View >
  )
}
export default TutorialPreview;